import { useEffect, useState } from "react";
import { FaChevronUp } from "react-icons/fa";

const ScrollToTopButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      setIsVisible(window.pageYOffset > 300);
    };

    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <>
      <style>
        {`
          .scroll-to-top-button {
            position: fixed;
            bottom: 30px;
            right: 30px;
            background-color: #C38745;
            color: #fff;
            border: none;
            border-radius: 50%;
            padding: 14px 16px;
            cursor: pointer;
            box-shadow: 0 4px 12px rgba(0,0,0,0.3);
            z-index: 9999;
            transition: transform 0.3s ease, box-shadow 0.3s ease;
          }

          .scroll-to-top-button:hover {
            transform: scale(1.15);
            animation: pulse 0.6s ease-in-out;
            box-shadow: 0 6px 16px rgba(0, 0, 0, 0.4);
          }

          @keyframes pulse {
            0% { transform: scale(1.05); }
          }
        `}
      </style>

      {isVisible && (
        <button
          onClick={scrollToTop}
          className="scroll-to-top-button"
          aria-label="Scroll to top"
        >
          <FaChevronUp size={20} />
        </button>
      )}
    </>
  );
};

export default ScrollToTopButton;
